import api from '../../api/vo2api'


import BaseEntity from './BaseEntity';
let baseEntity = new BaseEntity({

    getEntityType() {
        return 'organization';
    },

    getEmptyName() {
        return '(empty name)'
    },

    getById(id) {
        return api.getOrganization(id)
    },

    deleteById(orgId, entity) {
        return api.deleteOrganization(orgId, entity)
    },

    getItems() {
        return api.getOrganizationList()
    },

    insertOrUpdate(orgId, entity) {
        return api.insertOrUpdateOrganization(entity);
    },

    getEntityId(entity) {
        if(entity) {
            return entity.organizationId;
        }
        return null
    },

    augmentEntity( base, entity ) {
        return entity
    }
});

const state = {
    ...baseEntity.state,
};
const getters = {
    ...baseEntity.getters,
};
const actions = {
    ...baseEntity.actions,
};
const mutations = {
    ...baseEntity.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};